export default {"src":"/uk/_next/static/media/piggy-bank.686d3969.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};